import React from 'react';
import SABadge from './SABadge';
import NotificationBell from '../common/NotificationBell';
import '../../assets/styles/SuperAdmin/SATheme.css';

const SAHeader = ({ page, time, setAuthenticated, onLogout, activeLabel, onNavigate }) => {
    return (
        <header style={{
            padding: "12px 28px",
            borderBottom: "1px solid var(--sa-border)",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            background: "var(--sa-surface)", flexShrink: 0
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 11, color: "var(--sa-dim)" }}>🛡️ Super Admin Panel</span>
                <span style={{ color: "var(--sa-dim)" }}>›</span>
                <span style={{ fontSize: 13, fontWeight: 700, color: "var(--sa-text)", fontFamily: "'Sora', sans-serif" }}>{activeLabel}</span>
                <SABadge color="red" dot>RESTRICTED ACCESS</SABadge>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 11, color: "var(--sa-dim)" }}>
                    {time.toLocaleString("en-IN", { weekday: "short", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}
                </span>
                <div style={{ width: 1, height: 20, background: "var(--sa-border)" }} />
                {/* Notification Bell */}
                <NotificationBell
                    onNavigate={onNavigate}
                    iconStyle={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', color: 'var(--sa-text)' }}
                />
                <button
                    onClick={() => setAuthenticated(false)}
                    style={{
                        background: "rgba(229, 57, 53, 0.1)", color: "var(--sa-accent)",
                        border: "1px solid rgba(229, 57, 53, 0.2)",
                        padding: "6px 14px", borderRadius: 8, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans'"
                    }}
                >
                    🔒 Lock Panel
                </button>
                <button
                    onClick={onLogout}
                    style={{
                        background: "rgba(183, 28, 28, 0.1)", color: "var(--sa-muted)",
                        border: "1px solid rgba(183, 28, 28, 0.2)",
                        padding: "6px 14px", borderRadius: 8, fontSize: 11, fontWeight: 700, cursor: "pointer", fontFamily: "'DM Sans'"
                    }}
                >
                    ⏏ Sign Out
                </button>
            </div>
        </header>
    );
};

export default SAHeader;
